// extracted by mini-css-extract-plugin
export default {"top":"Modal_top__DPlfC","close-icon":"Modal_close-icon__6wyrE","logo":"Modal_logo__7M2Lj"};